import ResponsiveImage, { RawImageProps } from '../../ResponsiveImage';

export const Image: React.FC<RawImageProps> = (props) => {
  return (
    <div className="[&>span]:!tw-block">
      <ResponsiveImage {...props} />
    </div>
  );
};
